import React from "react";
import { Link } from "react-router-dom";
import { emitOpenConsentPreferences } from "../../utils/consent";

// Cookie Preferences / Cookie Policy / Do Not Sell links. Shown in the Footer and on the home
// page (which has no footer), so the opt-out stays reachable from every page.
const linkClass =
  "text-white/90 hover:text-white transition-colors text-xs font-medium underline-offset-2 hover:underline";

const LegalLinks = ({ className = "", style }) => (
  <div
    className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 ${className}`}
    style={{ fontFamily: "Geogrotesque, sans-serif", ...style }}
  >
    <button
      type="button"
      onClick={() => emitOpenConsentPreferences("footer-link")}
      className={`${linkClass} bg-transparent border-0 cursor-pointer p-0`}
    >
      Cookie Preferences
    </button>
    <span className="text-white/80 text-xs">|</span>
    <Link to="/cookie-policy" className={linkClass}>
      Cookie Policy
    </Link>
    <span className="text-white/80 text-xs">|</span>
    <Link to="/do-not-sell-or-share" className={linkClass}>
      Do Not Sell or Share My Personal Information
    </Link>
  </div>
);

export default LegalLinks;
